import { FCI_ERROR } from "@searchui-searchforms/shared/fci";
import { fciFetch } from "@/shared/lib/fci";
import type { SelectedPlace } from "./types";

export const getCategoryPlaceData = (query: { gpid: string; culture: string }) =>
    fciFetch<SelectedPlace[]>(`/api/getCategoryPlaceData?${new URLSearchParams(query)}`, {
        fci: {
            // Used to enrich/resolve display details for a place
            // that's already been chosen — in PlaceExactness, HierarchicalGroup, and LocationSlider
            // If it fails, the form still works — the place is already selected,
            // this just fills in supplementary display info like the human-readable name or exactness options
            errorType: FCI_ERROR.TransparentSubstitution,
            errorInfo: "getCategoryPlaceData",
        },
    });
